import { useEffect, useState } from 'react'

import Flex from '~/components/Flex'
import ListLoader from '~/components/ListLoader'

export default function HudLoading() {
  const [mounted, setMounted] = useState(false)

  // don't show spinner unless 20ms have elapsed
  useEffect(() => {
    const timeout = setTimeout(() => {
      setMounted(true)
    }, 20)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <Flex flexDirection="column" height="calc(100vh - 100px)" overflow="hidden" paddingX={16}>
      {mounted && <ListLoader />}
    </Flex>
  )
}
